import { render } from "./show.vue?vue&type=template&id=6b46e03c&scoped=true"
import script from "./show.vue?vue&type=script&lang=ts"
export * from "./show.vue?vue&type=script&lang=ts"

import "./show.vue?vue&type=style&index=0&id=6b46e03c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b46e03c"

export default script